<template>
  <v-menu
    :close-on-content-click="false"
    transition="scale-transition"
    origin="top right"
    offset-y
    bottom
    left
  >
     <template v-slot:activator="{ on, filter }">
      <v-btn v-bind="filter" v-on="on" class="mr-n3" color="primary" elevation="0" outlined small>
        <span class="caption">
          {{ $t('hausefulInvoices.filters.title') }}
        </span>
        <v-icon right small>
          mdi-filter-outline
        </v-icon>
      </v-btn>
    </template>
    <v-card class="px-3 pt-2 pb-3 mw-350">
      <!-- requireFullRange: a busca desta tela é cara (varre a payment inteira e agrupa tudo em
           memória), então não vale disparar com o intervalo pela metade. -->
      <FilterDatesRange
        :fetchData="fetchHausefulInvoices"
        startDateProp="startDate"
        endDateProp="endDate"
        requireFullRange
      />
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions } from 'vuex'

import FilterDatesRange from '../../../../components/filters/FilterDatesRange'

export default {
  name: 'HausefulInvoiceListFilters',

  components: {
    FilterDatesRange,
  },

  methods: {
    ...mapActions(['fetchHausefulInvoices']),
  },
}
</script>
